import FeaturedTopicsContainer from "../../components/FeaturedTopics/FeaturedTopicsContainer";
import formatSlug from "../../utils/formatSlug";
import gettingStartedArray from "../../utils/gettingStartedArray";

const GettingStarted: React.FC = () => {
  return (
    <div className="getting-started-container">
      <p>
        <a href="/" className="breadcrumb-link">
          Help Desk
        </a>{" "}
        &#10132; Getting Started
      </p>
      <div className="row">
        <div className="col-main">
          <h2 className="help-heading">Getting Started</h2>
          {gettingStartedArray.map((item, key) => {
            const slug = formatSlug(item.title, true, false);

            return (
              <p key={key} className="getting-started-title">
                <a
                  className="getting-started-title"
                  key={key}
                  href={`/getting-started/${slug}`}
                >
                  {item.title}
                </a>
              </p>
            );
          })}
        </div>
        <div className="col-main-1">
          <FeaturedTopicsContainer />
        </div>
      </div>
    </div>
  );
};

export default GettingStarted;
